import { getTranslation } from '~/lib/i18n-utils'
import { formatPrice } from '~/utils/format'
import { useLocale } from '~/contexts/LocaleContext'

export default function BookingSummaryExtraService({
  extra_guest_desc,
}: {
  extra_guest_desc?: number
}) {
  const { locale } = useLocale()
  const t = getTranslation(locale)
  return (
    <div className={`rounded-[6px] bg-[#F3F3F3] p-[10px]`}>
      <div
        className={`mb-[10px] flex items-center justify-between text-[10px] leading-[14px] md:text-[12px] md:leading-4`}
      >
        <div className={`ml-4 list-item w-1/2 list-disc text-[#2D2E32]`}>
          {t('booking.extra_service_childOver6')}
        </div>
        <div className={`font-normal`}>
          {extra_guest_desc
            ? `${formatPrice(extra_guest_desc, locale)}/${t('booking.person')}/${t('booking.nights')}`
            : ''}
        </div>
      </div>
      <div
        className={`ml-4 list-item list-disc text-[10px] leading-[14px] text-[#2D2E32] md:text-[12px] md:leading-4`}
      >
        {t('booking.extra_service_childUnder6')}
      </div>
    </div>
  )
}
